import axios from "axios";
import getToken from "../../../config/getToken";
import { convertFileToBase64Dynamic } from "../../../utils/functions";
import { env } from "../../../env";

axios.interceptors.response.use(
  (response) => {
    if (response.data.responseCode === 1016 || response.status === 403) {
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = "/";
    } else {
      return response;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export async function GetDynamicReportConf(mainUser) {
  const token = await getToken();
  return axios({
    method: "GET",
    url: `dinamicreport/${mainUser}`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

export async function CreateDynamicReportConf(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: "dinamicreport",
    data: data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

export async function UpdateDynamicReportConf(data) {
  const token = await getToken();
  return axios({
    method: "PUT",
    url: "dinamicreport",
    data: data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}
